import React from 'react';

export const InstallPrompt = ({ visible, isIos, hasPrompt, onInstall, onClose }) => {
  if (!visible) {
    return null;
  }

  const isManualInstall = !isIos && !hasPrompt;

  return (
    <div className="install-prompt" data-testid="install-prompt" role="dialog" aria-modal="true">
      <div className="install-prompt__card">
        <div>
          <strong>اپلیکیشن را روی صفحه اصلی نصب کنید</strong>
          <p className="mb-0 size-12 text-muted">
            {isIos
              ? 'در Safari روی دکمه اشتراک ضربه بزنید و گزینه «افزودن به صفحه اصلی» را انتخاب کنید.'
              : isManualInstall
                ? 'از منوی مرورگر گزینه Install یا «افزودن به صفحه اصلی» را انتخاب کنید.'
                : 'با زدن دکمه نصب می‌توانید اپ را خارج از مرورگر و سریع‌تر باز کنید.'}
          </p>
        </div>
        <div className="install-prompt__actions">
          <button
            type="button"
            className="btn btn-primary btn-sm"
            onClick={isManualInstall ? onClose : onInstall}
          >
            {isIos ? 'راهنمای نصب آیفون' : isManualInstall ? 'متوجه شدم' : 'نصب اپ'}
          </button>
          <button type="button" className="btn btn-link text-muted btn-sm" onClick={onClose}>
            بعدا
          </button>
        </div>
      </div>
    </div>
  );
};

export const IosInstallGuide = ({ visible, onClose }) => {
  if (!visible) {
    return null;
  }

  return (
    <div className="install-guide-overlay" role="dialog" aria-modal="true">
      <div className="install-guide-card">
        <h6 className="mb-3">نصب اپلیکیشن روی آیفون</h6>
        <p>
          برای اضافه کردن اپ به صفحه اصلی کافی است در Safari موارد زیر را انجام دهید:
        </p>
        <ol className="ps-3 mb-3">
          <li>روی آیکون اشتراک (مربع با پیکان روبه‌بالا) ضربه بزنید.</li>
          <li>گزینه «افزودن به صفحه اصلی» را انتخاب کنید.</li>
          <li>در پنجره بازشده، «افزودن» را لمس کنید تا آیکون روی صفحه اصلی ظاهر شود.</li>
        </ol>
        <button type="button" className="btn btn-light btn-sm" onClick={onClose}>
          متوجه شدم
        </button>
      </div>
    </div>
  );
};
